import $ from "jquery";
import { Modal, Carousel } from "bootstrap";
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "productIndex")
        return;
    var $modal = $("#productPopup");
    var modal = Modal.getOrCreateInstance($modal[0], { backdrop: true, keyboard: true, focus: true });
    var $inner = $("#productPopupInner");
    var $dots = $("#productPopupDots");
    var $title = $("#productPopupTitle");
    var carouselEl = document.getElementById("productPopupCarousel");
    var carousel = Carousel.getOrCreateInstance(carouselEl, {
        interval: false,
        ride: false,
        wrap: true,
        touch: true, // mobile swipe
    });
    function render(images) {
        $inner.empty();
        $dots.empty();
        images.forEach(function (url, i) {
            var active = i === 0 ? "active" : "";
            $inner.append("\n        <div class=\"carousel-item ".concat(active, "\">\n          <img class=\"zuba-product-modal-img\" src=\"").concat(url, "\" alt=\"\">\n        </div>\n      "));
            $dots.append("<button type=\"button\" class=\"".concat(i === 0 ? "is-active" : "", "\" data-dot=\"").concat(i, "\" aria-label=\"Slide ").concat(i + 1, "\"></button>"));
        });
        // reset na prvý slide
        carousel.to(0);
    }
    function setActiveDot(index) {
        $dots.find("button").removeClass("is-active");
        $dots.find("button[data-dot=\"".concat(index, "\"]")).addClass("is-active");
    }
    // Open popup
    $(document).on("click", ".js-product-popup", function (e) {
        var _a, _b;
        e.preventDefault();
        var title = String((_a = $(this).data("popup-title")) !== null && _a !== void 0 ? _a : "");
        $title.text(title);
        var raw = (_b = $(this).attr("data-popup-images")) !== null && _b !== void 0 ? _b : "[]";
        var images = [];
        try {
            images = JSON.parse(raw);
        }
        catch (_c) {
            images = [];
        }
        if (!images || images.length === 0)
            return;
        render(images);
        modal.show();
    });
    // Dots click
    $(document).on("click", "#productPopupDots button", function () {
        var i = parseInt(String($(this).data("dot")), 10);
        if (!isNaN(i)) {
            carousel.to(i);
        }
    });
    // Update dots on slide
    $(carouselEl).on("slid.bs.carousel", function () {
        var idx = $(carouselEl).find(".carousel-item.active").index();
        setActiveDot(idx);
    });
    // Desktop drag (pointer)
    var startX = null;
    var dragging = false;
    $(document).on("pointerdown", "#productPopupCarousel", function (ev) {
        var _a, _b;
        startX = (_b = (_a = ev.originalEvent) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : null;
        dragging = true;
    });
    $(document).on("pointerup pointercancel", "#productPopupCarousel", function () {
        startX = null;
        dragging = false;
    });
    $(document).on("pointermove", "#productPopupCarousel", function (ev) {
        var _a, _b;
        if (!dragging || startX === null)
            return;
        var x = (_b = (_a = ev.originalEvent) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : startX;
        var dx = x - startX;
        // threshold pre "swipe"
        if (Math.abs(dx) > 60) {
            dx < 0 ? carousel.next() : carousel.prev();
            startX = null; // aby to neskákalo viac krát jedným ťahom
            dragging = false;
        }
    });
    // Reset pri zavretí
    $modal.on("hidden.bs.modal", function () {
        $inner.empty();
        $dots.empty();
        $title.text("");
    });
});
//# sourceMappingURL=productIndex.js.map